var _circle, _circle2, _circle3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilterSettings = function SvgIconFilterSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.167,
    cy: 5.834,
    r: 3.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.833,
    cy: 13.416,
    r: 3.5,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 22.166,
    r: 3.5,
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.333,
    height: 2.333,
    x: 2.333,
    y: 4.666,
    fill: "#fff",
    rx: 1.167
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.333,
    height: 2.333,
    x: 2.333,
    y: 12.25,
    fill: "#fff",
    rx: 1.167
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 23.333,
    height: 2.333,
    x: 2.333,
    y: 21,
    fill: "#fff",
    rx: 1.167
  })));
};
export default SvgIconFilterSettings;